<template>
  <div class="default-box">
    <h2>スケジュール</h2>
    <p class="description">
      内容を変更したい日付をクリックすると、スケジュールの編集画面が表示されます。
    </p>
    <div class="calerndar">
      <div class="header">
        <div class="date-wrapper">
          <p class="prev" @click="next_prev_click(-1)">＜ 前月</p>
          <p class="month">{{ select_year }}年{{ select_month }}月</p>
          <p class="next" @click="next_prev_click(1)">次月 ＞</p>
        </div>
      </div>
      <div class="week">
        <div class="week-t">日</div>
        <div class="week-t">月</div>
        <div class="week-t">火</div>
        <div class="week-t">水</div>
        <div class="week-t">木</div>
        <div class="week-t">金</div>
        <div class="week-t">土</div>
      </div>
      <table>
        <tbody>
          <tr v-for="(item, index) in date_arr" :key="index">
            <td
              v-for="(date, date_index) in item"
              :key="date_index"
              :class="{
                td_disabled: date === '',
                selected_td: select_ymd.substr(6, 2) == date,
                now_date: now_date_check(date)
              }"
              @click="date_click(date, date_index)"
            >
              <p
                class="date"
                :class="{
                  holiday: holiday_check(date, date_index),
                  saturday: saturday_check(date, date_index)
                }"
              >
                {{ date }}
              </p>
              <draggable
                v-model="schedule_data[get_ymd(date)]"
                v-bind="drag_option"
                :group="`sch-${get_ymd(date)}`"
                @change="sch_sort(get_ymd(date))"
              >
                <div
                  class="sch-item"
                  v-for="(sch_item, sch_indx) in schedule_data[get_ymd(date)]"
                  :key="sch_indx"
                  :class="`reservable-${sch_item.reservable_flag}`"
                  @click.stop="sch_list_click(sch_item, date_index)"
                >
                  <p
                    class="sch-item-date"
                    v-html="timeDisp(sch_item.start_time, sch_item.end_time)"
                  />
                  <p
                    class="sch-item-content"
                    v-html="sch_item.content.replace(/\n/g, '<br>')"
                  />
                </div>
              </draggable>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <el-dialog :visible.sync="dialogFormVisible">
      <div v-if="select_ymd !== ''" class="input-box">
        <p class="input-title">日時</p>
        <p class="input-content">{{ select_date_make }}</p>
        <div class="time-input">
          <el-time-select
            placeholder="Start time"
            v-model="start_time"
            :picker-options="{
              start: '06:00',
              step: '00:15',
              end: '23:45'
            }"
          >
          </el-time-select>
          <span>〜</span>
          <el-time-select
            placeholder="End time"
            v-model="end_time"
            :picker-options="{
              start: '06:00',
              step: '00:15',
              end: '23:45',
              minTime: start_time
            }"
          >
          </el-time-select>
        </div>
        <p class="input-title">URL</p>
        <input type="text" class="input-url" v-model="url" />
        <p class="input-title">内容</p>
        <div class="radio-box">
          <div v-for="radio_item in radio_lists" :key="radio_item.value">
            <input
              v-model="reservable_flag"
              :id="'reservation_' + radio_item.value"
              type="radio"
              :value="radio_item.value"
            />
            <label :for="'reservation_' + radio_item.value">{{
              radio_item.label
            }}</label>
          </div>
        </div>
        <textarea class="reservation-text" v-model="reservation_text" />
        <input type="button" class="update_btn" @click="update" value="保存" />
        <input
          v-if="schedule_id"
          type="button"
          class="delete_btn"
          @click="deleteConfirmVisible = true"
          value="削除"
        />
      </div>
    </el-dialog>

    <el-dialog
      class="delete-confirm-dialog"
      :visible.sync="deleteConfirmVisible"
    >
      <p>削除しますか？(削除したデータは戻せません)</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="sch_delete">削除する</el-button>
        <el-button type="primary" @click="deleteConfirmVisible = false"
          >キャンセル</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "Default",
  // ===========================================================================
  // components
  // ===========================================================================
  components: { draggable },
  // ===========================================================================
  // data
  // ===========================================================================
  data() {
    return {
      now_ymd: "",
      select_ymd: "",
      select_week: 0,
      select_year: "",
      select_month: "",
      start_date_obj: null,
      end_date: 0,
      schedule_id: null,
      reservable_flag: 1,
      reservation_text: "",
      schedule_data: {},
      radio_lists: [
        {
          value: 1,
          label: "移動販売"
        },
        {
          value: 2,
          label: "直売所"
        },
        {
          value: 3,
          label: "イベント"
        }
      ],
      content_lists: [],
      start_time: "",
      end_time: "",
      url: "",
      dialogFormVisible: false,
      deleteConfirmVisible: false
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    drag_option() {
      return {
        animation: 100
      };
    },
    holiday_data() {
      return this.$store.getters["Holiday/holiday_ist"];
    },
    date_arr() {
      if (this.start_date_obj === null) {
        return [];
      }
      let week_numm = this.start_date_obj.getDay();
      let i, j;
      let res_arr = [];
      let counter = 0;

      for (i = 0; i < 6; i++) {
        res_arr[i] = [];
        for (j = 0; j < 7; j++) {
          if (i === 0 && week_numm > j) {
            res_arr[i].push("");
            continue;
          }
          counter++;
          if (counter > this.end_date) {
            res_arr[i].push("");
            continue;
          }
          res_arr[i].push(counter);
        }
      }

      return res_arr;
    },
    select_date_make() {
      if (this.select_ymd === "") {
        return "";
      }
      let week_arr = ["日", "月", "火", "水", "木", "金", "土"];
      return (
        this.select_ymd.substr(0, 4) +
        "年" +
        String(parseInt(this.select_ymd.substr(4, 2), 10)) +
        "月" +
        String(parseInt(this.select_ymd.substr(6, 2), 10)) +
        "日" +
        "(" +
        week_arr[this.select_week] +
        ")"
      );
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created() {},
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted() {
    const now_date = new Date();
    this.now_ymd = this.$lib._date_text_get(now_date);
    this.select_date_set(now_date.getFullYear(), now_date.getMonth() + 1);
    this.load_data();
    // this.load_content_data();
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed() {},
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    load_data() {
      let disp_ym = this.get_ymd(1).substr(0, 6);
      let ld = new this.$loader(this);
      ld._data_set({ month: disp_ym });
      ld._post_cb_f = this.load_data_cb;
      ld._load_start("/manage/month_schedule_get.php");
    },
    load_data_cb(data) {
      if (data.res === 1) {
        let schedules = data.data.schedules;
        let schedule_data = {};
        for (let i = 0; i < schedules.length; i++) {
          if (
            Object.prototype.toString.call(schedule_data[schedules[i].date]) !==
            "[object Array]"
          )
            schedule_data[schedules[i].date] = [];
          schedule_data[schedules[i].date].push(schedules[i]);
        }
        this.schedule_data = schedule_data;
      } else {
        this.$alert("alert", `エラーコード：${data.res}`);
      }
    },
    timeDisp(start_time, end_time) {
      let str = "";
      if (start_time || end_time)
        str = `${start_time ? start_time : ""} 〜 ${end_time ? end_time : ""}`;
      return str;
    },
    get_ymd(date) {
      let set_date = ("00" + String(date)).slice(-2);
      let set_month = ("00" + String(this.select_month)).slice(-2);
      let ymd = String(this.select_year) + String(set_month) + String(set_date);
      return ymd;
    },
    select_date_set(year, month) {
      let start_date_obj = new Date(year, month - 1, 1);
      let end_date_obj = new Date(year, month, 0);
      this.start_date_obj = start_date_obj;
      this.end_date = end_date_obj.getDate();
      this.select_year = year;
      this.select_month = month;
    },
    next_prev_click(num) {
      let start_date_obj = new Date(
        this.select_year,
        this.select_month - 1 + num,
        1
      );
      this.select_date_set(
        start_date_obj.getFullYear(),
        start_date_obj.getMonth() + 1
      );
      this.select_ymd = "";
      this.load_data();
    },
    now_date_check(date) {
      if (date === "") {
        return false;
      }
      const check_date = this.get_ymd(date);

      if (check_date === this.now_ymd) {
        return true;
      }
      return false;
    },
    holiday_check(date, week_no) {
      if (date === "") {
        return "";
      }
      if (week_no === 0) {
        return true;
      }
      let ymd = this.get_ymd(date);
      if (this.holiday_data[ymd]) {
        return true;
      }
      return false;
    },
    saturday_check(date, week_no) {
      if (date === "") {
        return "";
      }
      if (week_no === 6) {
        return true;
      }
      return false;
    },
    schedule_data_get(date) {
      if (date === "") {
        return "";
      }
      let ymd = this.get_ymd(date);
      if (this.schedule_data[ymd]) {
        return this.schedule_data[ymd].content.replace(/\n/g, "<br>");
      }
      return "";
    },
    reservable_check(date) {
      let ymd = this.get_ymd(date);
      if (this.schedule_data[ymd]) {
        return this.schedule_data[ymd].reservable_flag;
      }
      return 1;
    },
    reservable_str_get(date) {
      if (date === "") {
        return "";
      }
      let ymd = this.get_ymd(date);
      if (this.schedule_data[ymd]) {
        if (parseInt(this.schedule_data[ymd].reservable_flag, 10) === 1) {
          return "移動販売";
        } else if (
          parseInt(this.schedule_data[ymd].reservable_flag, 10) === 2
        ) {
          return "直売所";
        } else if (
          parseInt(this.schedule_data[ymd].reservable_flag, 10) === 3
        ) {
          return "イベント";
        }
      }
      return "";
    },
    date_click(date, week_no) {
      if (date === "") {
        return;
      }
      this.dialogFormVisible = true;
      this.select_week = week_no;
      this.select_ymd = this.get_ymd(date);
      /*       if (
        this.schedule_data[this.select_ymd] &&
        this.schedule_data[this.select_ymd][0]
      ) {
        const data = this.schedule_data[this.select_ymd][0];
        this.schedule_id = data.id;
        this.reservable_flag = data.reservable_flag;
        this.url = data.url;
        this.reservation_text = data.content;
        this.start_time = data.start_time;
        this.end_time = data.end_time;
      } else {
        this.schedule_id = null;
        this.reservable_flag = 1;
        this.url = "";
        this.reservation_text = "";
        this.start_time = null;
        this.end_time = null;
      } */

      this.schedule_id = null;
      this.reservable_flag = 1;
      this.url = "";
      this.reservation_text = "";
      this.start_time = null;
      this.end_time = null;
    },
    sch_list_click(data, week_no) {
      if (!data) return false;
      this.select_week = week_no;
      this.select_ymd = data.date;
      this.dialogFormVisible = true;
      this.schedule_id = data.id;
      this.reservable_flag = data.reservable_flag;
      this.url = data.url;
      this.reservation_text = data.content;
      this.start_time = data.start_time;
      this.end_time = data.end_time;
    },
    update() {
      let obj = {};
      if (this.schedule_id !== null) {
        obj.id = this.schedule_id;
      }
      obj.date = this.select_ymd;
      obj.start_time = this.start_time;
      obj.end_time = this.end_time;
      obj.url = this.url;
      obj.content = this.reservation_text;
      obj.reservable_flag = this.reservable_flag;
      let ld = new this.$loader(this);
      ld._data_set({ schedule: obj });
      ld._post_cb_f = this.update_cb;
      ld._load_start("/manage/schedule_edit.php");
      this.dialogFormVisible = false;
    },
    update_cb(data) {
      if (data.res === 1) {
        this.schedule_id = data.data.id;
        this.load_data();
        this.$alert("alert", "保存しました");
      } else {
        this.$alert("alert", `エラーコード：${data.res}`);
      }
    },
    sch_delete() {
      let obj = {};
      if (this.schedule_id === null) return false;
      obj.id = this.schedule_id;
      let ld = new this.$loader(this);
      ld._data_set(obj);
      ld._post_cb_f = this.delete_cb;
      ld._load_start("/manage/schedule_del.php");

      this.dialogFormVisible = false;
      this.deleteConfirmVisible = false;
      this.schedule_id = null;
      this.select_week = 0;
      this.select_ymd = this.now_ymd;
      this.reservable_flag = 1;
      this.url = "";
      this.reservation_text = "";
      this.start_time = null;
      this.end_time = null;
    },
    delete_cb(data) {
      if (data.res === 1) {
        this.load_data();
        this.$alert("alert", "削除しました");
      } else {
        this.$alert("alert", `エラーコード：${data.res}`);
      }
    },
    sch_sort(date) {
      console.log(this.schedule_data[date]);

      let obj = {};
      if (!this.schedule_data[date]) return false;
      obj.schedules = [];
      for (let i = 0; i < this.schedule_data[date].length; i++) {
        obj.schedules.push({ id: this.schedule_data[date][i].id });
      }
      console.log(obj.schedules);
      let ld = new this.$loader(this);
      ld._data_set(obj);
      ld._post_cb_f = this.sort_cb;
      ld._load_start("/manage/schedule_sort.php");
    },
    sort_cb(data) {
      if (data.res === 1) {
        this.load_data();
        console.log('sorted');
      } else {
        this.$alert("alert", `エラーコード：${data.res}`);
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {}
};
</script>

<style lang="scss">
@import "~element-ui/lib/theme-chalk/icon.css";
@import "~element-ui/lib/theme-chalk/input.css";
@import "~element-ui/lib/theme-chalk/time-select.css";
@import "~element-ui/lib/theme-chalk/time-picker.css";
@import "~element-ui/lib/theme-chalk/dialog.css";
@import "~element-ui/lib/theme-chalk/button.css";

.el-dialog {
  width: 460px;
}

.el-dialog__header {
  padding: 0;
}

.el-dialog__body {
  display: flex;
  flex-flow: row wrap;
}

.el-dialog__headerbtn {
  top: 10px;
  right: 10px;
}

.el-dialog__close {
  font-size: 30px;
}

.delete-confirm-dialog {
  .dialog-footer {
    display: flex;
    justify-content: space-between;
  }
}

.default-box {
  h2 {
    color: #6c5a57;
    text-align: left;
  }

  .description {
    color: #6c5a57;
    text-align: left;
  }

  .sch-item {
    text-align: left;
    margin: 8px;
    padding: 0px 4px 4px;
    border-radius: 8px;
    word-break: break-all;
  }

  .sch-item-date {
    &:before {
      content: " ";
      position: relative;
      top: 4px;
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
    }
  }

  .sch-item-content {
    font-weight: bold;
  }

  .reservable-1 {
    color: #945b0d;
    background: #fac479;

    .sch-item-date:before {
      background: url("../assets/sch_car.svg") top center no-repeat;
    }
  }

  .reservable-2 {
    color: #1d3031;
    background: #aedddf;
    .sch-item-date:before {
      background: url("../assets/sch_shop.svg") top center no-repeat;
    }
  }

  .reservable-3 {
    color: #c5062c;
    background: #f4c4ce;
    .sch-item-date:before {
      background: url("../assets/sch_event.svg") top center no-repeat;
    }
  }

  .calerndar {
    width: 1280px;

    .header {
      background: url("../assets/header_bg.svg") center top no-repeat;
      width: 100%;
      height: 400px;

      .date-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        padding: 140px 0;
        width: 490px;
      }
    }

    .next,
    .prev {
      background: #fef49e;
      width: 88px;
      font-size: 16px;
      font-weight: bold;
      line-height: 64px;
      text-align: center;
      color: #df274c;
      border-radius: 4px;
      cursor: pointer;
    }

    .month {
      background: url("../assets/date_bg.svg") center center no-repeat;
      width: 258px;
      height: 64px;
      font-size: 32px;
      line-height: 64px;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }

    .week {
      display: flex;
      position: relative;
      border-top: #df274c 3px solid;
      margin-top: -68px;
      background: #faebeb;
      padding: 24px 45px 0;
      justify-content: space-around;

      &:before {
        content: " ";
        display: block;
        position: absolute;
        top: -22px;
        left: calc(50% - 20px);
        width: 40px;
        height: 40px;
        background: url("../assets/calendar_ribbon.svg") center center no-repeat;
      }

      .week-t {
        background: url("../assets/leaf.svg") center top no-repeat;
        height: 56px;
        box-sizing: border-box;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        line-height: 56px;
        color: #ffffff;
        width: 160px;
      }

      .week-t:first-child {
        background: url("../assets/leaf_sun.svg") center top no-repeat;
      }

      .week-t:last-child {
        background: url("../assets/leaf_sat.svg") center top no-repeat;
      }
    }

    table {
      width: 100%;
      table-layout: fixed;
      background: #faebeb;
      padding: 0 20px;
      border-collapse: separate;
      border-spacing: 15px 24px;

      td {
        width: 160px;
        vertical-align: top;
      }

      tbody {
        tr {
          height: 160px;

          td {
            background: #fff;
            border-radius: 8px;
            cursor: pointer;

            .date {
              background: url("../assets/dot_line.svg") -4px bottom repeat-x;
              background-size: 16px 4px;
              text-align: left;
              font-size: 24px;
              line-height: 44px;
              font-weight: bold;
              padding: 0 12px;
            }

            .saturday {
              color: #66e;
            }

            .holiday {
              color: #e66;
            }

            &.now_date {
              background: #fef6b1;

              border: #e4cd03 2px solid;
            }

            /*             .sch-item {
              text-align: left;
              margin: 8px;
              padding: 0px 4px 4px;
              border-radius: 8px;
              word-break: break-all;
            }

            .sch-item-date {
              &:before {
                content: " ";
                position: relative;
                top: 4px;
                display: inline-block;
                width: 24px;
                height: 24px;
                line-height: 24px;
              }
            }

            .sch-item-content {
              font-weight: bold;
            }

            .reservable-1 {
              color: #945b0d;
              background: #fac479;

              .sch-item-date:before {
                background: url("../assets/sch_car.svg") top center no-repeat;
              }
            }

            .reservable-2 {
              color: #1d3031;
              background: #aedddf;
              .sch-item-date:before {
                background: url("../assets/sch_shop.svg") top center no-repeat;
              }
            }

            .reservable-3 {
              color: #c5062c;
              background: #f4c4ce;
              .sch-item-date:before {
                background: url("../assets/sch_event.svg") top center no-repeat;
              }
            } */
          }

          .td_disabled {
            background-color: #dddddd;
            cursor: default;
          }
        }

        td:not(.td_disabled):hover {
          background-color: #fdf6ce;
        }

        .selected_td {
          background-color: #fdf6ce;
        }
      }
    }
  }

  .input-box {
    margin-top: 20px;
    width: 100%;
    text-align: left;

    .input-title {
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      font-size: 1.2rem;
      font-weight: bold;
      border-left: 6px solid #6c5a57;
    }

    .input-content {
      margin: 10px;
    }

    .radio-box {
      margin: 10px 10px 0;
      display: flex;
    }

    .content-box {
      display: flex;
      flex-wrap: wrap;
      margin: 8px;

      .button {
        padding: 2px 8px;
        margin-right: 16px;
      }
    }

    .time-input {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 20px);
      margin: 10px;

      .el-date-editor.el-input {
        width: 180px;
      }
    }

    .input-url {
      margin: 10px;
      height: 40px;
      width: calc(100% - 20px);
    }

    .reservation-text {
      margin: 10px;
      height: 150px;
      width: calc(100% - 20px);
    }

    .update_btn,
    .delete_btn {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px;
      width: calc(100% - 20px);
      font-size: 16px;
      margin: 0 10px;
      text-decoration: none;
      border-radius: 3px;
    }

    .delete_btn {
      margin-top: 20px;
      background: red;
    }
  }

  /*   .sch-list {
    width: 50%;
    height: 500px;
    overflow: auto;
    text-align: left;
  } */
}

@media (max-width: 767px) {
  .el-dialog {
    width: 80%;
  }

  .el-dialog__body {
    flex-flow: column-reverse wrap;
  }

  .default-box {
    .calerndar {
      width: 100%;

      .header {
        background: url("../assets/sp/header_bg.svg") center top no-repeat;
        background-size: contain;
        height: 57.5vw;

        .date-wrapper {
          max-width: 75vw;
          width: 90%;
          padding: 21.2vw 0 0;

          .month {
            width: 40.31vw;
            height: 9.99vw;
            font-size: 4.99vw;
            line-height: 9.99vw;
          }

          .prev,
          .next {
            width: 13.75vw;
            line-height: 10vw;
            font-size: 3vw;
          }
        }
      }

      .week {
        display: none;
      }

      table {
        margin-top: -5vw;
        padding: 24px 24px 8px;
        border-spacing: 0;

        tbody {
          tr {
            height: auto;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;

            td {
              width: 100%;
              min-height: 88px;
              margin-bottom: 16px;
            }
          }
        }
      }
    }

    .input-box,
    .sch-list {
      width: 100%;
    }

    /*     .sch-list {
      height: auto;
    } */
  }
}
</style>
